import React from "react";
import { Footer } from "./Footer";
import { AdZoneFooter } from "@/features/ad-zones/components/AdZonePlacements";
import { Header } from "./layout/Header";
import { PageTitle } from "./layout/PageTitle";
import { PageBreadcrumbs } from "./layout/PageBreadcrumbs";
import { AdZoneBanner } from "@/features/ad-zones/components/AdZonePlacements";
import { useAppShell } from "./layout/AppShellContext";
import { layoutStyle } from "./layout/constants";
import { SidebarProvider } from "@/components/ui/sidebar";
import { cn } from "@/lib/utils";
import { toolPageClass, toolPagePaddingClass } from "./layout/toolContent";

interface PageLayoutProps {
  children: React.ReactNode;
  title: React.ReactNode;
  description: string;
  breadcrumbs?: { label: string; path: string }[];
  reliabilityLevel?: 1 | 2 | 3 | 4 | 5;
  /** Contenu pleine largeur sans max-w centré (ex. tableaux larges) */
  fullWidth?: boolean;
}

export const PageLayout = ({
  children,
  title,
  description,
  breadcrumbs = [],
  reliabilityLevel,
  fullWidth = false,
}: PageLayoutProps) => {
  const { hasShell } = useAppShell();

  const contentWrapperClass = cn(
    toolPageClass,
    toolPagePaddingClass,
    !fullWidth && "lg:max-w-7xl lg:mx-auto"
  );

  const content = (
    <>
      <PageBreadcrumbs items={breadcrumbs} />
      <PageTitle
        title={title}
        description={description}
        reliabilityLevel={reliabilityLevel}
      />
      {children}
    </>
  );

  if (hasShell) {
    return (
      <div className="flex flex-col w-full min-w-0 max-w-full">
        <div className={contentWrapperClass}>{content}</div>
        <AdZoneFooter />
        <Footer />
      </div>
    );
  }

  return (
    <SidebarProvider>
      <div className="flex flex-col min-h-dvh w-full min-w-0" style={layoutStyle}>
        <Header />
        <div className="flex flex-col flex-1 w-full min-w-0 pt-[var(--header-h)]">
          <AdZoneBanner />
          <div className={contentWrapperClass}>{content}</div>
          <AdZoneFooter />
          <Footer />
        </div>
      </div>
    </SidebarProvider>
  );
};
